export const SCOPE_NAMES: Record<string, string> = {
  GLOBAL: "Global (all regions)",
  EMEA: "Europe, Middle East & Africa",
  APAC: "Asia Pacific",
  LATAM: "Latin America",
  CARIBBEAN: "Caribbean",
};
